<template>
	<v-container>
		<form>
			<div v-show="showFilters">
				<!-- Mandator -->
				<v-row>
					<v-col cols="12" md="12">
						<autocomplete-basic
							:items="formItems.mandator"
							:model.sync="formState.selectedMandators"
							label="Mandator"
							:errorCount="mandatorErrorCount"
							:errorMessage="mandatorErrorMessage"
							v-show="mandatorVisible"
						/>
					</v-col>
				</v-row>

				<!-- Service Provider -->
				<v-row>
					<v-col cols="12" md="12">
						<autocomplete-basic
							:items="formItems.serviceproviders"
							:model.sync="formState.selectedServiceproviders"
							label="Serviceprovider"
						/>
					</v-col>
				</v-row>
				<!-- Gate group and gates -->
				<v-row>
					<v-col cols="12" md="6">
						<autocomplete-basic
							:items="formItems.gateGroups"
							:model.sync="formState.selectedGateGroups"
							label="Gate Groups"
						/>
					</v-col>
					<v-col cols="12" md="6">
						<autocomplete-basic
							:items="formItems.gates"
							:model.sync="formState.selectedGates"
							label="Gate"
						/>
					</v-col>
				</v-row>

				<!-- Start and End date / time -->
				<v-row>
					<v-col cols="12" md="6">
						<date-time-picker
							dateLabel="Redemption Start date"
							timeLabel="Redemption Start time"
							:time="startTime"
							:date="startDate"
							:substractDayFromCurrent="7"
							@datetimeEmit="setStartTime"
						/>
					</v-col>
					<v-col cols="12" md="6">
						<date-time-picker
							dateLabel="Redemption End date"
							timeLabel="Redemption End time"
							:date.sync="endDate"
							:time.sync="endTime"
							@datetimeEmit="setEndTime"
						/>
					</v-col>
				</v-row>

				<!--  Product SKU / name  and Product category (e.g. Autoverlad) -->
				<v-row>
					<v-col cols="12" :md="mdColSkuProd">
						<autocomplete-basic
							:items="formItems.productSku"
							:model.sync="formState.selectedProductSku"
							label="Product SKU"
							:show="showSkuAutocomplete"
						/>
					</v-col>
					<v-col cols="12" :md="mdColSkuProd">
						<autocomplete-basic
							:items="formItems.productCategories"
							:model.sync="formState.selectedProductCategory"
							label="Product Categories"
							:show="showProductCatAutocomplete"
						/>
					</v-col>
				</v-row>

				<!-- Ticket holder info (= filtering on name or email) and ticket identifier -->
				<v-row>
					<v-col cols="12" md="6">
						<!-- name or email -->
						<v-text-field
							v-model="formState.ticketHolderInfo"
							label="Ticket holder info"
							persistent-hint
							return-object
							:error-messages="ticketHolderInfoErrors"
							:hint="txt.ticketHolderInfoHint"
							@input="$v.formState.ticketHolderInfo.$touch()"
							@blur="$v.formState.ticketHolderInfo.$touch()"
						/>
					</v-col>
					<v-col cols="12" md="6">
						<v-text-field
							v-model="formState.ticketIdentifier"
							label="Ticket identifier"
							persistent-hint
							return-object
						/>
					</v-col>
				</v-row>
			</div>
			<v-btn
				color="secondary"
				class="searchButton ml-5"
				@click="showFilters = true, showButtonForFilters = false"
				v-show="showButtonForFilters"
				:disabled="isLoading"
			>
				{{ txt.button.backToFilters }}
			</v-btn>
			<v-btn
				color="rgb(0, 160, 227)"
				class="searchButtonShowData"
				@click="submitFilters"

				v-show="!showButtonForFilters"
			>
				{{ txt.button.showData }}
			</v-btn>
			<v-btn
				class="searchButton ml-5"
				@click="excelExport"
				:disabled="isLoading"
				v-show="showButtonForFilters"
			>
				{{ txt.button.excelExport }}
			</v-btn>
		</form>
	</v-container>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import { minLength } from 'vuelidate/lib/validators'
import AutocompleteBasic from '../vueBasics/AutocompleteBasic.vue'
import DateTimePicker from '../arcCustom/datetimePicker.vue'

export default {
	name: 'ValidityCheckerFilter',
	components: {
		AutocompleteBasic,
		DateTimePicker,
	},
	validations: {
		formState: {
			ticketHolderInfo: {
				minLength: minLength(2),
			},
		},
	},
	props: {
		appNameShort: {
			type: String,
			required: true,
		},
		isLoading: {
			type: Boolean,
			default: false,
		},
		search: {
			type: String,
		},
		sort: {
			type: Object,
		},
	},
	data() {
		return {
			appName: this.appNameShort,
			formState: {
				selectedMandators: [],
				selectedServiceproviders: [],
				selectedGateGroups: [],
				selectedGates: [],
				selectedProductCategory: [],
				selectedProductSku: [],
				ticketHolderInfo: '',
				ticketIdentifier: '',
			},
			formItems: {
				mandator: [],
				serviceproviders: [],
				gateGroups: [],
				gates: [],
				productCategories: [],
				productSku: [],
			},
			txt: {
				mandatorAlert: 'Please select at least one mandator.',
				button: {
					showData: 'Show data',
					excelExport: 'Excel Export',
					backToFilters: 'Show Filters',
				},
				error: {
					atLeastTwoChar: 'Type at least two characters',
				},
				ticketHolderInfoHint: 'E-mail or name of customer',
			},
			timeProps: {
				format: '24hr',
			},
			mandatorErrorCount: 0,
			mandatorErrorMessage: '',
			showButtonForFilters: false,
			mandatorVisible: true,
			showFilters: true,
			startTime: moment({ hour: 0, minute: 0 }).format('HH:mm'),
			startDate: moment(),
			startDateTime: new Date(),
			endTime: moment({ hour: 23, minute: 55 }).format('HH:mm'),
			endDate: moment(),
			endDateTime: new Date(),
		}
	},
	watch: {
		'formItems.mandator': {
			handler() {
				this.mandatorAutofill()
				this.notEmptyMandator()
			},
		},
		'formState.selectedMandators': {
			handler() {
				this.popFirstMandator(this.formState.selectedMandators)
				this.notEmptyMandator()
				this.getServiceProviders()
				this.getGates()
				this.getGateGroups()
				this.getProductSkuName()
			},
		},
	},
	computed: {
		ticketHolderInfoErrors() {
			const errors = []
			if (!this.$v.formState.ticketHolderInfo.$dirty) return errors
			!this.$v.formState.ticketHolderInfo.minLength && errors.push(this.$data.txt.error.atLeastTwoChar)
			return errors
		},
		showSkuAutocomplete() {
			return !((this.formState.selectedProductCategory.length > 0))
		},
		showProductCatAutocomplete() {
			return !((this.formState.selectedProductSku.length > 0))
		},
		mdColSkuProd() {
			return (this.showSkuAutocomplete == false || this.showProductCatAutocomplete == false) ? 12 : 6
		},
	},
	methods: {
		mandatorAutofill() {
			if (this.formItems.mandator.length === 1) {
				this.formState.selectedMandators = this.formItems.mandator
				this.mandatorVisible = false
			}
		},
		notEmptyMandator() {
			if (this.formState.selectedMandators.length === 0) {
				this.mandatorErrorCount = 1
				this.mandatorErrorMessage = 'Required field'
			} else {
				this.mandatorErrorCount = 0
				this.mandatorErrorMessage = ''
			}
		},
		popFirstMandator(mandators) {
			// remove the first item of the mandator array -> only one at the time
			if (mandators.length > 1) {
				this.formState.selectedMandators.shift()
			}
		},
		async getMandators(appName) {
			try {
				// eslint-disable-next-line no-undef
				const res = await axios.get(`${config.baseAPIurl}/validity-checker/mandators?appNameShort=${appName}`)
				this.$data.formItems.mandator = res.data
			} catch (err) {
				console.log(err)
			}
		},
		async getServiceProviders() {
			if (this.$data.formState.selectedMandators.length == 0) return
			try {
				// eslint-disable-next-line max-len, no-undef
				const res = await axios.get(`${config.baseAPIurl}/validity-checker/service-provider?selectedMandator=${this.$data.formState.selectedMandators[0].value}`)
				this.formItems.serviceproviders = res.data
			} catch (err) {
				console.log(err)
			}
		},
		async getGates() {
			if (this.$data.formState.selectedMandators.length == 0) return
			try {
				// eslint-disable-next-line max-len, no-undef
				const res = await axios.get(`${config.baseAPIurl}/validity-checker/gates?selectedMandator=${this.$data.formState.selectedMandators[0].value}`)
				this.formItems.gates = res.data
			} catch (err) {
				console.log(err)
			}
		},
		async getGateGroups() {
			if (this.$data.formState.selectedMandators.length == 0) return
			try {
				// eslint-disable-next-line max-len, no-undef
				const res = await axios.get(`${config.baseAPIurl}/validity-checker/gate-groups?selectedMandator=${this.$data.formState.selectedMandators[0].value}`)
				this.formItems.gateGroups = res.data
			} catch (err) {
				console.log(err)
			}
		},
		async getProductSkuName() {
			if (this.$data.formState.selectedMandators.length == 0) return
			try {
				// eslint-disable-next-line max-len, no-undef
				const res = await axios.get(`${config.baseAPIurl}/validity-checker/product-sku-name-group?selectedMandator=${this.$data.formState.selectedMandators[0].value}`)
				this.formItems.productSku = res.data.productNamesAndSkus
				this.formItems.productCategories = res.data.productCategories
			} catch (err) {
				console.log(err)
			}
		},
		submitFilters() {
			if (this.mandatorErrorCount && this.mandatorErrorCount > 0) {
				// TODO: show alert
				return
			}
			// add concatineted datetime to the formstate object
			// eslint-disable-next-line function-paren-newline
			Object.assign(this.formState,
				{ startDateTime: this.startDateTime },
				{ endDateTime: this.endDateTime },
			)
			this.showButtonForFilters = true
			this.showFilters = false
			const submitObject = {
				errorCount: this.mandatorErrorCount,
				errorMessage: this.mandatorErrorMessage,
				formState: this.formState,
				excelExport: false,
			}
			this.$emit('submit', submitObject)
		},
		excelExport() {
			const submitObject = {
				errorCount: this.mandatorErrorCount,
				errorMessage: this.mandatorErrorMessage,
				formState: this.formState,
				excelExport: true,
				pagination: 1,
				search: this.search,
				sort: this.sort,
			}
			this.$emit('excelExport', submitObject)
		},
		setStartTime(value) {
			this.startDateTime = value
		},
		setEndTime(value) {
			this.endDateTime = value
		},
	},
	mounted() {
		this.$nextTick(() => {
			this.getMandators(this.$data.appName)
		})
	},
}
</script>

<style>
.searchButtonShowData{
	color: rgb(56, 56, 56) !important;
}
</style>
